import { useQueryClient } from '@tanstack/react-query'
import { useAuthMutation } from './auth'
import { ApiStudentRequest, request } from '../utils/request'
import { getDateOnlyFromString } from '../utils'
import { UpdatePassportByIdRequest } from '@backend/students-api/routes/documents/passports/{id}/PATCH/types'
import { PassportResource } from '@backend/resources/student-document'

export type UpdatePassportParams = UpdatePassportByIdRequest['data']['attributes'] & { id: string }

type RawPassportResponse = {
  data: PassportResource
}

export function useUpdatePassport() {
  const queryClient = useQueryClient()

  const { isPending, mutate } = useAuthMutation(
    async (params: UpdatePassportParams) => {
      return await request<RawPassportResponse>(
        new ApiStudentRequest(`/documents/passports/${params.id}`, {
          method: 'PATCH',
          body: {
            data: {
              type: 'passport',
              attributes: {
                passportNumber: params?.passportNumber ?? null,
                expiryDate: params?.expiryDate ? getDateOnlyFromString(params.expiryDate) : null,
                nationality: params?.nationality ?? null,
              },
            },
          },
        }),
        {
          isExpectedResponse: (res): res is RawPassportResponse => res as boolean,
        },
      )
    },
    {
      onSuccess: data => {
        queryClient.setQueryData(['passport'], data)
      },
    },
  )

  return {
    isUpdatingPassport: isPending,
    updatePassport: mutate,
  }
}
